import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PlanCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: 16px;
  position: relative;
  text-align: center;
  overflow: hidden;
`

export const PlanHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
`

interface CardTopProps {
  disabled?: boolean
}

export const CardTop = styled.div<CardTopProps>`
  display: flex;
  opacity: ${({ disabled }) => (disabled ? '30%' : '100%')};
  align-items: center;
  justify-content: space-between;
  padding: ${Spacing.S24} ${Spacing.S32} 0;
  border-radius: 16px 16px 0 0;
  text-align: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
`

interface CardCenterProps {
  disabled?: boolean
}

export const CardCenter = styled.div<CardCenterProps>`
  opacity: ${({ disabled }) => (disabled ? '30%' : '100%')};
  flex-grow: 1;
  margin-top: -2px;
  padding: ${Spacing.S8} ${Spacing.S32} ${Spacing.S24};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
`

export const PriceContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
`
